export default __webpack_public_path__ + "static/media/next.fb730cc2.svg";